import React from "react";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ExperienceSection from "./components/ExperienceSection";
import ProjectsSection from "./components/ProjectsSection";
import OpenSourceSection from "./components/OpenSourceSection";
import ContactFooter from "./components/ContactFooter";

export default function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-[#09090B] transition-colors duration-300">
        <Header />
        <main>
          <HeroSection />
          <ExperienceSection />
          <ProjectsSection />
          <OpenSourceSection />
          <ContactFooter />
        </main>
      </div>
    </ThemeProvider>
  );
}